let fixedFactor, sizeIncrement = window.sizeIncrement;
if(mrkType == 'sticker')
    fixedFactor = window.sticker_factor2;
else
    fixedFactor = window.label_factor_2;
// Function to get selected value from radio buttons
function getSelectedValue(name) {
    return $('input[name="' + name + '"]:checked').val();
}

// Function to get attribute from selected radio
function getSelectedAttribute(name, attr) {
    return $('input[name="' + name + '"]:checked').attr(attr) || 0;
}
function getProductWeight(quantity) {
    const type = window.mrkType; // 'sticker' or 'label'
    // stickers: 16 oz per 100 ⇒ 0.16 oz each
    // labels:   8 oz per 100 ⇒ 0.08 oz each
    const ozPerUnit = type === 'sticker' ? 16 / 100 : type === 'label' ? 8 / 100 : 0;
    return quantity * ozPerUnit;
  }
// Function to format money using Shopify
function formatMoney(amount) {
    return Shopify.formatMoney(amount, window.money_format);
}
function autoSelectDefaults() {
    let inputNames = ["shape", "size", "quantity", "laminates", "easy-peel", "Proof Options"];

    inputNames.forEach(name => {
        let $options = $('input[name="' + name + '"]');
        if ($options.length > 0 && $options.filter(":checked").length === 0) {
            $options.first().prop("checked", true).trigger("change"); // Select first option & trigger change event
        }
    });
}
function AutoFileSet(fileUrl, input) {
    // Extract and decode the file name from the URL
    const urlParts = fileUrl.split('/');
    const rawFileName = urlParts[urlParts.length - 1].split('?')[0].split('#')[0];
    const fileName = decodeURIComponent(rawFileName); // <-- decode URL-encoded name
    fetch(fileUrl)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], fileName, { type: blob.type });
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
  
        const $input = $(input);
        $input[0].files = dataTransfer.files;
  
        // Trigger jQuery change event
        $input.trigger('change');
      })
      .catch(err => console.error("File fetch error:", err));
  }
function uploadFile(){
    $(".mrk-upload-input").on("change", function (event) {
        let container = $(this).parents('.mrk-upload-inner-card');
        $(container).find(".mrk-uploaded-items").empty();
        let file = event.target.files[0];
        if (!file) return;
        let newFileName = file.name.replace(/[^a-zA-Z0-9._]/g, '_');
        let renamedFile = new File([file], newFileName, { type: file.type });
        let formData = new FormData();
        formData.append("file", renamedFile);

        // Read the file and convert to Base64 for preview
        let reader = new FileReader();
        reader.onload = function (e) {
            let imageURI = e.target.result;
            if(file.type.includes('pdf')){
                imageURI = window.mrkPdfFile;
            }else if(file.type.includes('postscript') || file.type.includes('.ai') || file.type.includes('.svg') || file.type.includes('.eps') || file.type.includes('.cdr')){
                imageURI = window.mrkAiFile;
            }
            // Clone the template and append to the upload list
            let $template = $("#mrk-uploaded-image-template").html();
            let $uploadItem = $($template).clone();

            $uploadItem.find(".mrk-uploaded-item-image img").attr("src", imageURI);
            $uploadItem.find(".mrk-uploaded-item-name").text(file.name);
            $uploadItem.find(".mrk-file-size").text((file.size / 1024).toFixed(2) + " KB");
            $(container).find(".mrk-uploaded-items").append($uploadItem);
            $(container).find(".mrk-loader-item").css("--width", "0%");
        };
        reader.readAsDataURL(file);

        // Ajax Upload with Progress
        $.ajax({
            url: "https://jetpackstickers.store/api/upload",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            xhr: function () {
                let xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (event) {
                    if (event.lengthComputable) {
                        let percentComplete = (event.loaded / event.total) * 100;
                        $(container).find(".mrk-loader-item").css("--width", percentComplete + "%");

                        let timeLeft = ((event.total - event.loaded) / event.loaded) * 5; // Estimate time left
                        $(container).find(".mrk-file-upload-message").text(`${Math.ceil(timeLeft)} seconds left`);
                    }
                }, false);
                return xhr;
            },
            success: function (response) {
                $(container).find('.mrk-hidden-file').val(`https://jetpackstickers.store${encodeURI(response.fileUrl)}`);
                $(container).find(".mrk-loader-item").css("--width", "100%");
                $(container).find(".mrk-file-upload-message").text("Uploaded Successfully");
                $(container).find(".mrk-uploaded-item").addClass("image-uploaded");
                setTimeout(function(){
                    $(container).find('.mrk-upload-btn-item').click();
                },100)
            },
            error: function () {
                $(container).find(".mrk-file-upload-message").text("Upload failed");
            }
        });
    });
}
// Function to calculate price
function calculatePrice(e) {
    if(e){
        var $input = $(e.target);
    
        if ($input.hasClass('validate-input')) {
            var min = parseFloat($input.attr('min')) || 0;
            var max = parseFloat($input.attr('max')) || Infinity;
            var step = parseFloat($input.attr('step')) || 1;
            var value = parseFloat($input.val()) || 0;
            
            // Clamp the value between min and max
            if (value > max) {
                value = max;
            } else if (value < min) {
                value = min;
            }

            // Round the value to the nearest step
            // value = Math.round(value / step) * step;

            // To prevent rounding issues (like 0.30000000004)
            value = parseFloat(value.toFixed(10));
            
            // Set the corrected value back to input
            $input.val(value);
        }
    }
    let materialFactor = parseFloat(getSelectedAttribute("material", "multiplier_factor"));
    let shape = getSelectedValue("shape");
    let price_increase = parseFloat(getSelectedAttribute("production", "price"));
    let width = parseFloat(getSelectedAttribute("size", "width")) || Math.ceil(parseFloat($('input[name="custom-width"]').val()) / sizeIncrement) * sizeIncrement;
    let height = parseFloat(getSelectedAttribute("size", "length")) || Math.ceil(parseFloat($('input[name="custom-height"]').val()) / sizeIncrement) * sizeIncrement;
    let quantity = parseFloat(getSelectedValue("quantity")) || parseFloat($('input[name="custom-quantity"]').val());
    let basePrice = parseFloat(getSelectedAttribute("easy-peel", "base"));
    let jobAdder = parseFloat(getSelectedAttribute("easy-peel", "job_adder"));
    let peelAdder = parseFloat(getSelectedAttribute("easy-peel", "size_adder"));
    let artwork = getSelectedAttribute("easy-peel", "artwork") === "true";
    if(mrkType == 'label'){
        basePrice = parseFloat(getSelectedAttribute("material", "base"));
        jobAdder = parseFloat(getSelectedAttribute("material", "job_adder"));
        peelAdder = parseFloat(getSelectedAttribute("material", "size_adder"));
    }
    let mrkFinalPrice = 0;
    // Area Calculation
    let totalSqInches = (width + peelAdder) * height;

    // Updated Formula Calculation
    let totalPrice = (materialFactor * Math.pow(totalSqInches, fixedFactor)) + (quantity * basePrice) + jobAdder;
    let multiplier = 1;
    if(price_increase > 0){
        multiplier = 1 + (price_increase / 100)
    }
    // Apply price per item
    let pricePerItem = totalPrice / quantity;
    console.log(price_increase);
    // Update price display
    $(".mrk-price-value").each(function () {
        let qty = parseFloat($(this).attr("quantity"));
        
        if (isNaN(qty)) {
            qty = parseFloat(getSelectedValue("quantity")) || parseFloat($('input[name="custom-quantity"]').val());
        }
    
        let area = totalSqInches * qty;
        let calculatedPrice = (materialFactor * Math.pow(area, fixedFactor)) + (qty * basePrice) + jobAdder;
        let final_price = Math.round(calculatedPrice) * 100;
        $(this).find(".mrk-final-price").text(formatMoney(final_price).replace('.00', ''));
        $(this).find(".mrk-price-per-item").text(formatMoney(final_price / qty));
    
        if (qty === quantity && isNaN(parseFloat(getSelectedValue("quantity"))) == false && $(this).hasClass('mrk-custom-qty') == false) {
            $(".mrk-price-value").removeClass("mrk-price-active");
            $('.mrk-summary-final-price').html(formatMoney(final_price * multiplier));
            mrkFinalPrice = final_price * multiplier;
            $(this).addClass("mrk-price-active");
        }
        if (isNaN(parseFloat(getSelectedValue("quantity")))) {
            $('.mrk-summary-final-price').html(formatMoney(final_price * multiplier));
            mrkFinalPrice = final_price * multiplier;
            $('.mrk-custom-qty').find(".mrk-final-price").text(formatMoney(final_price).replace('.00', ''));
            $('.mrk-custom-qty').find(".mrk-price-per-item").text(formatMoney(final_price / qty));
        }
    });
    
    if (isNaN(parseFloat(getSelectedValue("quantity")))) {
        $(".mrk-price-value").removeClass("mrk-price-active");
        $('.mrk-custom-qty').addClass("mrk-price-active");
    }
    
    // QR Code & Artwork Toggle
    let qrEnabled = getSelectedAttribute("easy-peel", "qr") === "true";
    if(getSelectedAttribute("qr-code-location", "qr") == "true"){
        qrEnabled = true
    }
    $(".mrk-qr-code-wrapper").toggleClass("mrk-disabled", !qrEnabled).find('textarea').prop("disabled",!qrEnabled);
    $(".mrk-sticker-peel-artwork-upload").toggleClass("mrk-disabled", !artwork);

    updateSummary(shape, width, height, quantity, artwork);
    return mrkFinalPrice;
}
function finalizeMedia(title, size, message, url){
    let $template = $("#final-selected-file").html();
    let $uploadItem = $($template).clone();

    $uploadItem.find(".mrk-selected-file-preview img").attr("src", url);
    $uploadItem.find(".mrk-summary-file-remove-btn").attr("url", url);
    $uploadItem.find(".mrk-selected-file-name").text(title);
    $uploadItem.find(".mrk-file-upload-message").text(message);
    $uploadItem.find(".mrk-file-size").text(size);
    $(".mrk-selected-files").append($uploadItem);
    if(url){
        $('.mrk-selected-files').parents(".mrk-order-summary-item").show();
        setTimeout(function(){
            $('[name="Send Artwork Later"]').prop('checked', false).trigger('change');
        },100)
    }
}

function mrkValidate(qrCodeLink, sendArtworkLater, peelArtworkUrl, imageUrl) {
    sendArtworkLater = sendArtworkLater || false;
    let valid = true;
    let message = "";

    // Array to keep track of missing fields so we can show a specific message
    let missingFields = [];
    if($(".mrk-qr-code-wrapper").length){
        // Check if QR code should be enabled
        let qrEnabled = getSelectedAttribute("easy-peel", "qr") === "true";
        $(".mrk-qr-code-wrapper")
            .toggleClass("mrk-disabled", !qrEnabled)
            .find('textarea')
            .prop("disabled", !qrEnabled);
        
        if (qrEnabled) {
            if (!qrCodeLink || qrCodeLink.trim() === "") {
                $(".mrk-qr-code-wrapper").addClass("mrk-required-field");
                valid = false;
                missingFields.push("add QR code link");
            }
        }
    }
    if($('[name="Final Artwork"]').length){
        // Check Final Artwork field validation
        if ((!imageUrl || imageUrl.trim() === "") && !sendArtworkLater) {
            $('[name="Final Artwork"]').closest('div').addClass("mrk-required-field");
            valid = false;
            missingFields.push("Upload Final Artwork or select Send artwork later");
        }
    }
    if($(".mrk-sticker-peel-artwork-upload").length){
        // Check if Peel Artwork field should be validated
        let peelArtworkEnabled = !$(".mrk-sticker-peel-artwork-upload").hasClass("mrk-disabled");
        if (peelArtworkEnabled) {
            if ((!peelArtworkUrl || peelArtworkUrl.trim() === "") && !sendArtworkLater) {
                $('[name="Final Peel tab Artwork"]').closest('div').addClass("mrk-required-field");
                valid = false;
                missingFields.push("Peel Artwork");
            }
        }
    }
    // Build a message for the user based on the validation result
    if (!valid) {
        message = "Please " + missingFields.join(", ") + ".";
    } else {
        message = "Validation successful.";
    }
    
    // Return the validation status and message together as an object
    return { valid: valid, message: message };
}
function updateSummary(shape, width, height, quantity, artwork) {
    // Shape, Size, Quantity
    $(".mrk-selected-shape").text(shape);
    $(".mrk-selected-size").text(`${width}" x ${height}"`);
    $(".mrk-selected-quantity").text(quantity);
    let imageUrl = $('[name="Final Artwork"]').val();
    if (artwork || imageUrl) {
        $('.mrk-selected-files').parents(".mrk-order-summary-item").show();
    } else {
        $('.mrk-selected-files').parents(".mrk-order-summary-item").hide();
    }
    // Helper function to handle text + visibility
    function setSummary(selector, value) {
        const $el = $(selector);
        $el.text(value);
        if (value) {
            $el.parents(".mrk-order-summary-item").show();
        } else {
            $el.parents(".mrk-order-summary-item").hide();
        }
    }
    $('[name="instructions"]').each(function(){
        var count = $(this).val().length;
        $(this).parents('.mrk-instructions-inner').find('.current-instructions-length').text(count)
    })
    // Update optional fields with show/hide logic
    setSummary(".mrk-selected-laminate", getSelectedValue("laminates"));
    setSummary(".mrk-selected-proof", getSelectedValue("Proof Options"));
    setSummary(".mrk-selected-easy-peel", getSelectedValue("easy-peel"));
    setSummary(".mrk-selected-unwind", getSelectedValue("unwind"));
    setSummary(".mrk-selected-qr-location", getSelectedValue("qr-code-location"));
    var sendLater = getSelectedValue("Send Artwork Later") ? 'Yes' : '';
    setSummary(".mrk-send-artwork-later", sendLater);
    if(sendLater == 'Yes'){
        $('.mrk-summary-file-remove-btn').each(function(){
            $(this).click();
        })
    }
}
function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (const [key, value] of params.entries()) {
        paramsObj[key] = decodeURIComponent(value);
    }
    return paramsObj;
}
function autoFillFromUrl() {
    const params = getUrlParams();
    if (!params || !Object.keys(params).length) return;

    // ─── map “raw” URL keys → your actual form-field names ───
    const paramToField = {
        "UV Laminate": "laminates",
        "Instructions": "instructions",
        "Quantity": "quantity",
        "QR Code Link": "qr-code-link",
        "Product Name": "product_name",
        "Easy Peel" : "easy-peel",
        "Send Artwork Later": "Send Artwork Later",
        "Proof Options": "Proof Options",
        "Custom Width": "custom-width",
        "Custom Height": "custom-height",
        "Artwork": "Artwork",
        "Peel Artwork": "Peel tab Artwork"
        // (everything else falls back to itself)
    };

    Object.entries(params).forEach(([rawName, rawValue]) => {
        if (!rawValue) return;
        const value = decodeURIComponent(rawValue);
        const field = paramToField[rawName] || rawName;
        if(value.includes('/files/') || value.includes('jetpackstickers.store')){
            const $fileInput = $(`[name="${field}"]`);
            console.log(field, value);
            // 4) your two file-upload widgets
            if (field === "Peel tab Artwork" || field === "Artwork") {
                AutoFileSet(value, $fileInput)
            }
        }else{
            // 1) radios & checkboxes
            const $choice = $(
                `input[name="${field}"][value="${value}"], input[name="${field}"][value="${encodeURIComponent(value)}"]`
            );
            if ($choice.length) {
                $choice.prop('checked', true).trigger('change');
                return;
            }

            // 2) <select> dropdowns
            const $sel = $(`select[name="${field}"]`);
            if ($sel.length) {
                $sel.val(value).trigger('change');
                return;
            }

            // 3) text inputs & textareas
            const $txt = $(`[name="${field}"]`);
            if ($txt.length && ($txt.is('input') || $txt.is('textarea'))) {
                $txt.val(value).trigger('change');
                return;
            }
        }
    });
}

$(document).ready(function () {
    autoSelectDefaults();
    // Event Listeners
    autoFillFromUrl();
    $('.mrk-stickers-main-content').on("change", calculatePrice);
    $(".mrk-final-add-to-cart").on("click", function () {
        // Collecting values from the page
        let qrEnabled = getSelectedAttribute("easy-peel", "qr") === "true";
        if(getSelectedAttribute("qr-code-location", "qr") == "true"){
            qrEnabled = true
        }
        let shape = getSelectedValue("shape");
        let unwindDirection = getSelectedValue("unwind");
        let width = parseFloat(getSelectedAttribute("size", "width")) || parseFloat($('input[name="custom-width"]').val());
        let height = parseFloat(getSelectedAttribute("size", "length")) || parseFloat($('input[name="custom-height"]').val());
        let size = `${width}” x ${height}”`;

        let laminates = getSelectedValue("laminates");
        let production = getSelectedValue("production");
        let easyPeel = getSelectedValue("easy-peel");
        if(qrEnabled){
            var qrCodeLink = $('[name="qr-code-link"]').val();
        }
        let qrCodeLocation = getSelectedValue("qr-code-location") || '';
        let sendArtworkLater = getSelectedValue("Send Artwork Later");
        let proofOptions = getSelectedValue("Proof Options");
        let instructions = $('[name="instructions"]').val();
        let peelArtworkUrl = $('[name="Final Peel tab Artwork"]').val();
        let imageUrl = $('[name="Final Artwork"]').val();
        let productName = $('[name="product_name"]').val();
        let material = getSelectedValue("material");
        let quantity = parseFloat(getSelectedValue("quantity")) || parseFloat($('input[name="custom-quantity"]').val());
        let weight = getProductWeight(quantity);
        let price = calculatePrice(); 
        let validate = mrkValidate(qrCodeLink, sendArtworkLater, peelArtworkUrl, imageUrl);
        
        if(!validate.valid){
            alert(validate.message);
            return;
        }
        var mainImage = imageUrl;
        if(imageUrl.includes('.pdf')){
            mainImage = window.mrkPdfFile;
        }else if(imageUrl.includes('.ai') || imageUrl.includes('.svg') || imageUrl.includes('.eps') || imageUrl.includes('.cdr')){
            mainImage = window.mrkAiFile;
        }
        // Preparing the data object
        let productData = {
            product_name: productName,
            shape: shape || productName,
            size: size,
            material: material,
            production:production,
            easypeel: easyPeel,
            uv_laminate: laminates,
            qr_code_location: qrCodeLocation,
            qrCodeLink: qrCodeLink || '',
            unwindDirection: unwindDirection || '',
            price: price,
            weight: weight,
            image_url: mainImage || defaultImageURL,
            send_artwork_later: sendArtworkLater,
            proof_options: proofOptions,
            instructions: instructions,
            peel_artwork: peelArtworkUrl
        };

        // Disable button to prevent multiple clicks
        $(".mrk-final-add-to-cart").attr("disabled", true).text("Adding...");

        // **Step 1: Create Product on Shopify**
        $.ajax({
            url: "https://jetpackstickers.store/api/create-product",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(productData),
            success: function (response) {
                var attachment = response.product.image?.src || mainImage;
                if(imageUrl.includes('.pdf')){
                    attachment = imageUrl;
                }else if(imageUrl.includes('.ai') || imageUrl.includes('.svg') || imageUrl.includes('.eps') || imageUrl.includes('.cdr')){
                    attachment = imageUrl;
                }
                if(attachment && $('[name="Send Artwork Later"]:checked').length){
                  attachment = '';
                }
                if (response.product && response.product.id) {
                    let variant_id = response.product.variants[0].id;
                    // **Step 2: Add Product to Cart as Line Item**
                    let lineItemData = {
                        id: variant_id,
                        quantity: 1,
                        properties: {
                            "Quantity": quantity,
                            "Artwork": attachment,
                            "Peel Artwork": peelArtworkUrl,
                            "QR Code Link": qrCodeLink,
                            "Easy Peel": easyPeel,
                            "Unwind Direction": unwindDirection,
                            "UV Laminate": laminates,
                            "QR Code Location": qrCodeLocation,
                            "Instructions": instructions,
                            "Send Artwork Later": sendArtworkLater,
                            "Proof Options": proofOptions,
                            "Production": production
                        }
                    };

                    $.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        contentType: "application/json",
                        data: JSON.stringify({ items: [lineItemData] }),
                        success: function () {
                            // $(".mrk-final-add-to-cart").text("Added to Cart ✅");
                            setTimeout(() => {
                                window.location.href = "/cart";
                            }, 1000);
                        },
                        error: function (error) {
                            console.error("Error adding to cart:", error);
                            $(".mrk-final-add-to-cart").text("Error! Try Again").removeAttr("disabled");
                        }
                    });
                } else {
                    console.error("Product creation failed:", response);
                    $(".mrk-final-add-to-cart").text("Error! Try Again").removeAttr("disabled");
                }
            },
            error: function (error) {
                console.error("Error creating product:", error);
                $(".mrk-final-add-to-cart").text("Error! Try Again").removeAttr("disabled");
            }
        });
    });
    $('.mrk-upload-main-btn button').click(function(){
        $(this).prop('disabled', true);
        let container = $(this).parents('.mrk-upload-inner-card'),
        title = $(container).find('.mrk-uploaded-item-name').text(),
        size = $(container).find('.mrk-file-size').text(),
        url = $(container).find('.mrk-hidden-file').val(),
        message = $(container).find('.mrk-file-upload-message').text();
        $(this).attr('url', url);
        if(url.includes('.pdf')){
            url = window.mrkPdfFile;
        }else if(url.includes('.ai') || url.includes('.svg') || url.includes('.eps') || url.includes('.cdr')){
            url = window.mrkAiFile;
        }
        finalizeMedia(title, size, message, url);
    })
    $(document).on('click', '.mrk-uploaded-file-remove', function(){
        let container = $(this).parents('.mrk-upload-inner-card');
        let url = $(this).parents('.mrk-upload-inner-card').find('.mrk-upload-btn-item').attr('url');
        $(container).find('.mrk-uploaded-items').empty();
        $(container).find('input').val('').trigger('change');
        $(`.mrk-summary-file-remove-btn[url="${url}"]`).click();
    });
    $(document).on('click', '.mrk-summary-file-remove-btn', function(){
        let item = $(this).parents('.mrk-selected-file-item');
        $(`.mrk-upload-main-btn button[url="${$(this).attr('url')}"]`).prop('disabled', false);
        $(`.mrk-upload-main-btn button[url="${$(this).attr('url')}"]`).parents('.mrk-upload-inner-card').find('.mrk-uploaded-file-remove-btn').click()
        $(item).remove();
    });
    $(document).on('click', '.mrk-deal-add-to-cart', function () {
        const variantId = getSelectedValue("selected_product");
        const artwork = $('.mrk-final-artwork').val()?.trim();
        const proof = getSelectedValue("Proof Options");
        const laminate = getSelectedValue("laminates");
        const instructions = $('[name="instructions"]').val()?.trim();
        const sendArtworkLater = getSelectedValue("Send Artwork Later");

        if (!variantId) {
            alert("Please select a product.");
            return;
        }

        if (!artwork && !sendArtworkLater) {
            alert("Please upload artwork or select 'Send Artwork Later'.");
            return;
        }

        // Build properties array for Shopify cart
        const properties = {
            "Artwork": artwork,
            "Proof Options": proof,
            "UV Laminate": laminate,
            "Instructions": instructions,
            "Send Artwork Later": sendArtworkLater
        };

        // Add to cart
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                quantity: 1,
                id: variantId,
                properties: properties
            },
            dataType: "json",
            success: function () {
                $(".mrk-deal-add-to-cart").text("Added to Cart ✅");
                setTimeout(() => {
                    window.location.href = "/cart";
                }, 1000);
        },
            error: function (err) {
            console.error("Error adding to cart:", err);
            alert("Something went wrong. Please try again.");
        }
        });
    });
    // Initial Calculation
    calculatePrice();
    uploadFile();
});